<template>
  <tippy
    v-tippy="{
      arrow: true,
      distance: 7,
      interactive: true,
      theme: '1xp light tooltip',
      zIndex: 10000,
      trigger: isMobileDevice ? 'click' : 'mouseenter focus',
    }"
  >
    <Button1XP
      :class="$style.downloadButton"
      end-icon="download"
      target="blank"
      :text="
        config.metadata.fileType && config.metadata.fileSize
          ? `${config.metadata.fileType} (${config.metadata.fileSize})`
          : config.title
      "
      :url="config.urls.url"
      variant="secondary"
    />

    <template v-if="config.urls.url && !config.hideTooltip" #content>
      <ul :class="$style.downloadLinks">
        <li>
          <Button1XP
            start-icon="docs"
            target="_blank"
            :text="config.urls.url.split(/\.(?=[^\.]+$)/)[1]"
            :url="config.urls.url"
            variant="linkStatic"
            @click="
              wtParams &&
              wtTrack(
                { cat: wtParams.doctype },
                {
                  ...wtParams,
                  filename: config.urls.url,
                },
              )
            "
          />
        </li>
      </ul>
    </template>
  </tippy>
</template>

<script setup>
import Button1XP from '../Button1XP/Button1XP.vue';

defineProps({
  config: {
    type: Object,
    default: () => {},
  },
  section: String,
  id: {
    type: String,
    default: '',
  },
  labels: {
    type: Object,
    default: () => {},
  },
  colour: {
    type: String,
    default: 'blue',
  },
  wtParams: Object,
});

const { wtTrack } = window;
</script>

<style module lang="scss">
@forward './DownloadButton.scss';
</style>
